const SessionHelper = {}

SessionHelper.saveSession = (session) => {
  const { accessToken, ...user } = session;
  const userSession = {
    userId: user._id,
    fullName: user.fullName,
    roles: user.roles,
    email: user.email,
    code: user.code,
    photo: user.photo,
    isImpersonate: user.isImpersonate || false,
    notifications: user.notifications || {}
  };

  const serializedUserSession = JSON.stringify(userSession);
  localStorage.setItem('accessToken', accessToken);
  localStorage.setItem('userSession', serializedUserSession);
};

SessionHelper.clearSession = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('userSession');
};

export default SessionHelper;